import React from "react";
import { withStyles } from "@mui/styles";
import CircularProgress from "@mui/material/CircularProgress";

const styles = (theme) => ({
  button: {
    backgroundColor: "#3CC87B",
    borderRadius: "3px",
    padding: "10px 15px",
    color: "#fff",
    cursor: "pointer",
    display: "inline-block",
    minWidth: 100,
    textAlign: "center",
  },
  secondaryButton: {
    backgroundColor: "#fff",
    border: "1px solid black",
    color: "#000",
  },
  spinner: {
    color: "#fff",
  },
  secondarySpinner: {
    color: "#000",
  },
});

function Button({
  classes,
  style,
  title,
  onClick,
  submitting,
  disabled,
  secondary,
}) {
  const buttonStyle = {
    ...style,
    ...(disabled ? { opacity: 0.4 } : {}),
  };

  const className = `${classes.button} ${
    secondary ? classes.secondaryButton : ""
  }`;
  const spinnerClass = secondary ? classes.secondarySpinner : classes.spinner;

  return (
    <div
      className={className}
      style={buttonStyle}
      onClick={(e) => {
        e.stopPropagation();
        !submitting && !disabled && onClick?.();
      }}
    >
      {!submitting && title}
      {submitting && <CircularProgress className={spinnerClass} size={14} />}
    </div>
  );
}

export default withStyles(styles)(Button);
